import { render, staticRenderFns } from "./SnowdownItem.vue?vue&type=template&id=4597aada&scoped=true"
import script from "./SnowdownItem.vue?vue&type=script&lang=js"
export * from "./SnowdownItem.vue?vue&type=script&lang=js"
import style0 from "./SnowdownItem.vue?vue&type=style&index=0&id=4597aada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597aada",
  null
  
)

export default component.exports